var SCM = SCM || {};

(function (ns, $) {
    var baseSiteUrl = $('#hfSiteURL');
    // init tab
    ns.initMyAccount = function () {

        var $myAcctTabsInnerWrap = $('.myaccount-tabs-inner-wrap'),
            $mobileNavIcon = $('.mobile-nav-icon'),
            $resizeTimer;

        // mobile page navigation
        $(document).on('click', '.myaccount-mobile-nav', function (e) {
            e.stopPropagation();
            $myAcctTabsInnerWrap.toggle();
            if ($mobileNavIcon.hasClass('icon-general-arrow-filled-down')) {
                $mobileNavIcon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-up');
            } else {
                $mobileNavIcon.removeClass('icon-general-arrow-filled-up').addClass('icon-general-arrow-filled-down');
            }
        });

        $(document).click(function () {
            $myAcctTabsInnerWrap.hide().removeAttr('style');
        });

        // Scroll
        $(window).on('scroll', function () {
            clearTimeout($resizeTimer);
            $resizeTimer = setTimeout(function () {
                $myAcctTabsInnerWrap.removeAttr('style'); // reset mobile page nav
            }, 50); // in milliseconds
        });

        // Resize
        $(window).on('resize', function () {
            clearTimeout($resizeTimer);
            $resizeTimer = setTimeout(function () {
                $myAcctTabsInnerWrap.removeAttr('style'); // reset mobile page nav
            }, 50); // in milliseconds
        });


        let $activeTab = $myAcctTabsInnerWrap.find('li.is-active');
        $('#myaccount-tabs').find('.myaccount-current-label').html($activeTab.text());

        registerKbartEvents();

        //edit personal details SIGMA
        $(document).on('click', '#myaccount-tabs-content .js-update-acct', function () {
            $('#updatePersonalDetailsBtn').addClass('disabled');
            let $formContainer = $('#myaccount-tabs-content');
            let fullname = $formContainer.find('#FullName').val();
            let phone = $formContainer.find('#Phone').val();
            let country = $formContainer.find('#CountryList').val();
            let token = $formContainer.find('#MyAccountToken').val();
            if (hasInputErrors(fullname, phone)) {
                return;
            }

            $.post('/OUPMyAccount/UpdateAccount',
                { fullname: fullname, phone: phone, country: country, token: token },
                function (data) {
                    $('#updatePersonalDetailsBtn').removeClass('disabled');
                    if (data != null) {
                        if (data.ReturnId) {
                            $formContainer.find('#MyAccountToken').val(data.ReturnId);
                        }
                        if (data.Success) {
                            updatePersonalInfo(data, fullname);
                        }
                        else {
                            showPersonalInfoErrors(data);
                        }
                    }
                });
        }); 

        //change password
        const initialErrorMessage = $('#change-password').find('.error-message').html();

        SCM.TestPassword.initTestPassword('#newPassword', '#confirmNewPassword', '#changePasswordBtn');

        $(document).on('click', '#changePasswordBtn', function () {
            const $formContainer = $('#myaccount-tabs-content');

            const $successMsg = $formContainer.find('.success-message');
            $successMsg.hide();

            const $errMsg = $formContainer.find('.error-message');
            $errMsg.html(initialErrorMessage).hide();

            const errors = {};
            let noInput = false;
            var currentPassword = $formContainer.find('#currentPassword').val();
            const newPassword = $formContainer.find('#newPassword').val();
            if (newPassword === '') {
                errors['newPassword'] = $('label[for="newPassword"]').text().replace('*', '');
                noInput = true;
            }
            const confirmNewPassword = $formContainer.find('#confirmNewPassword').val();
            if (confirmNewPassword === '') {
                errors['confirmNewPassword'] = $('label[for="confirmNewPassword"]').text().replace('*', '');
                noInput = true;
            }
            if (noInput)
            {
                for (const key in errors)
                {
                    $errMsg.append('<p> * ' + errors[key] + '</p>').show();
                }
                $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                return;
            }
            $errMsg.html('');

            const token = $formContainer.find('#MyAccountToken').val();

            const $submitButton = $formContainer.find('#changePasswordBtn');
            $submitButton.addClass('disabled');
            $.post('/OUPMyAccount/ChangePassword',
                {
                    currentPassword: currentPassword,
                    newPassword: newPassword,
                    confirmNewPassword: confirmNewPassword,
                    token: token
                },
                function (result) {
                    $submitButton.removeClass('disabled');
                    if (result) {
                        if (result.ReturnId) {
                            $formContainer.find('#MyAccountToken').val(result.ReturnId);
                        }

                        if (result.Messages && result.Messages.length && result.Messages[0] === '1') {
                            $successMsg.show();
                        } else {
                            if (result.Messages && result.Messages.length && result.Messages[1]) {
                                $errMsg.html(result.Messages[1]).show();
                            }
                            $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                        }
                    }
                });
        });

        //change email address
        const initialChangeEmailErrorMessage = $('#change-email-address').find('.error-message').html();
        $(document).on('click', '#changeEmailBtn', function () {
            const $formContainer = $('#change-email-address');

            const $successMsg = $formContainer.find('.success-message');
            $successMsg.html('');

            const $errMsg = $formContainer.find('.error-message');
            $errMsg.html(initialChangeEmailErrorMessage).hide();
            const errors = {};
            let noInput = false;

            const newEmailAddress = $formContainer.find('#newEmailAddress').val();
            if (newEmailAddress === '') {
                errors['newEmailAddress'] = $('label[for="newEmailAddress"]').text().replace('*', '');
                noInput = true;
            }
            const confirmNewEmailAddress = $formContainer.find('#confirmNewEmailAddress').val();
            if (confirmNewEmailAddress === '') {
                errors['confirmNewEmailAddress'] = $('label[for="confirmNewEmailAddress"]').text().replace('*', '');
                noInput = true;
            }
            const password = $formContainer.find('#currentPassword').val();
            if (typeof password !== 'undefined') {
                if (password === '') {
                    errors['password'] = $('label[for="currentPassword"]').text().replace('*', '');
                    noInput = true;
                }
            }
            if (noInput) {
                for (const key in errors) {
                    $errMsg.append('<p>' + errors[key] + '</p>').show();
                }
                $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                return;
            }
            $errMsg.html('');

            const token = $('#myaccount-tabs-content').find('#MyAccountToken').val();

            $.post('/OUPMyAccount/RequestEmailAddressChange',
                {
                    newEmailAddress: newEmailAddress,
                    confirmNewEmailAddress: confirmNewEmailAddress,
                    token: token
                },
                function (data) {
                    if (data != null) {
                        if (data.ReturnId) {
                            $('#myaccount-tabs-content').find('#MyAccountToken').val(data.ReturnId);
                        }

                        if (data.Messages == null || data.Messages[0] == null || data.Messages[0] == '') {
                            $formContainer.children('.change-email-address-form').hide();
                            $formContainer.children('.change-email-address-verification').show();
                        }
                        else {
                            $errMsg.html(data.Messages[0]).show();
                        }
                    }
                });
        });

        $(document).on('click', '#changeEmailVerificationBtn', function () {
            const $formContainer = $('#change-email-address');

            const $successMsg = $formContainer.find('.success-message');
            $successMsg.html('').hide();

            const $errMsg = $formContainer.find('.error-message');
            $errMsg.html('').hide();
            const verificationCode = $formContainer.find('#changeEmailVerificationCode').val();

            if (verificationCode.length > 0) {
                $.post('/OUPMyAccount/VerifyEmailAddressChange',
                    {verificationCode: verificationCode },
                    function (result) {
                        if (result[0] == '1')
                        {
                            //log out user after email address change
                            window.location.href = $formContainer.find('#hfSigmaLogoutUrl').val();
                        }
                        else {
                            $errMsg.html(result[1]).show();
                            $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                        }
                    });
            }
        });

        $('.js-newPassowrd').on('paste', function (e) {
            e.preventDefault();
            return false;
        });        
    };

    function registerKbartEvents() {
        $(document).on('click', '.js-kbart-submit-btn', function () {
            submitKbartReportRequest();
        });

        $(document).on('click', '.reveal-modal-bg', function (e) {
            closeKbartSubmitModal(e);
        });

        $('.js-kbart-submit-close').on('click', function (e) {
            closeKbartSubmitModal(e);
        });
    }

    function closeKbartSubmitModal(e) {
        var $submitModalDiv = $('#kbartSubmitModal');
        e.stopPropagation();
        $submitModalDiv.foundation('reveal', 'close');
        $('.js-kbart-submit-btn').removeClass('disabled');
        $('body').removeClass('kbart-disable-scroll');
    }

    function showKbartSubmitModal() {
        var $submitModalDiv = $('#kbartSubmitModal');
        var lastFocusedElement = document.activeElement;
        $submitModalDiv.off('opened.fndtn.reveal');
        $submitModalDiv.on('opened.fndtn.reveal', function () {
            $submitModalDiv.focus();
            SCM.trapFocus.publicTrapFocus($submitModalDiv, $submitModalDiv.find('.js-kbart-submit-close'), lastFocusedElement);
            $('body').addClass('kbart-disable-scroll');
        });
        $submitModalDiv.foundation('reveal', 'open');
    }

    function submitKbartReportRequest() {
        $('.js-kbart-error').addClass('hidden');
        var $submitBtn = $('.js-kbart-submit-btn');
        $submitBtn.addClass('disabled');
        var $selection = $('input[name="kbart-selection"]:checked');
        if ($selection.length) {
            var institutionID = $selection.val();
            var institutionName = $(`.kbart-institution[data-institutionid="${institutionID}"]`).text();
            var url = '/OUPKbart/GetKbartJournalFile';
            if ($selection.hasClass('js-kbart-book-download')) {
                url = '/OUPKbart/GetKbartBookFile';
            }
            var emailAddress = $('.js-kbart-email').val();
            if (emailAddress !== undefined) {
                $.post(url,
                    {
                        institutionAcctId: institutionID,
                        institutionName: institutionName,
                        emailAddress: emailAddress
                    },
                    function (result) {
                        if (result.Data === 'Success') {
                            showKbartSubmitModal();
                        } else if (result.Data === 'Invalid Email') {
                            $submitBtn.removeClass('disabled');
                            $('.js-invalid-kbart-email').parent().removeClass('hidden');
                        } else {
                            $submitBtn.removeClass('disabled');
                            $('.js-kbart-default-error').parent().removeClass('hidden');
                        }
                    })
                    .fail(function () {
                        $submitBtn.removeClass('disabled');
                        $('.js-kbart-default-error').parent().removeClass('hidden');
                    });
            }
        } else {
            $submitBtn.removeClass('disabled');
            $('.js-no-kbart-options').parent().removeClass('hidden');
        }
    }

    function hasInputErrors(fullname, phone) {
        var $formContainer = $('#myaccount-tabs-content');
        $formContainer.find('.success-message').html('').hide();
        $formContainer.find('.error-message').html('').hide();
        var brackets = /[<>]/;
        if (brackets.test(fullname) || brackets.test(phone)) {
            var bracketErr = $formContainer.find('#err-message-angle-brackets').html();
            $formContainer.find('.error-message').html(bracketErr).show();
            $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);

            return true;
        }
        return false;
    }

    function showPersonalInfoErrors(data) {
        var $formContainer = $('#myaccount-tabs-content');
        $formContainer.find('.error-message').html(data.Html).show();
        $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
    }

    function updatePersonalInfo(data, fullname) {
        var $formContainer = $('#myaccount-tabs-content');
        $('.js-header-account-info-user-fullname').html(fullname);
        $formContainer.find('.success-message').html(data.Html).show();
        // if signin box already created - update name
        var $name = $('.at-authenticated-user');
        if ($name.length && $name.text().length) {
            var names = $name.text().split(':');
            if (names.length > 0) {
                $name.text(names[0] + ': ' + fullname);
            }
        }
    }

    ns.initSavedSearches = function () {
        
        const $savedSearchesSorter = $('.solrSearchSaveWidget table.tablesorter');
        const delCol = $savedSearchesSorter.find('thead th').length - 1;
        
        // sort
        $savedSearchesSorter.tablesorter({
            theme: 'default',
            delayInit: true,
            ignoreCase: true,
            headers: { [delCol]: { sorter: false } },
            sortList: [[0, 0]]
        });

        // delete
        $('.solrSearchSaveWidget .save-search-delete').click(function () {
            SCM.MyAccount.deleteSaveSearch($(this));
        });

        // alert
        $('.solrSearchSaveWidget .ddlSearchAlertFrequencyMyAccount').change(function () {
            SCM.MyAccount.changeUserAlert($(this));
        });

        // rename
        $('.solrSearchSaveWidget .save-search-rename-rename').click(function () {
            var $parentElem = $(this).closest('td');
            var $searchNameLnk = $parentElem.find('.save-search-name-link');

            $searchNameLnk.hide();
            $parentElem.find('.save-search-input').val($searchNameLnk.text()).css('display', 'inline-block').focus();
            $parentElem.find('.save-search-rename-cancel').show();
            $parentElem.find('.save-search-rename-save').show();
            $(this).hide();
        });

        // cancel rename
        $('.solrSearchSaveWidget .save-search-rename-cancel').click(function () {
            var $parentElem = $(this).closest('td');

            $parentElem.find('.save-search-name-link').show();
            $parentElem.find('.save-search-input').hide();
            $parentElem.find('.save-search-rename-rename').show();
            $parentElem.find('.save-search-rename-save').hide();
            $(this).hide();
        });

        // save rename
        $('.solrSearchSaveWidget .save-search-rename-save').click(function () {
            var $saveLnk = $(this);
            var $parentElem = $saveLnk.closest('td');
            var $searchNameInput = $parentElem.find('.save-search-input');
            var $userSearchId = $saveLnk.closest('tr').data('usersearchid');
            var $newSearchName = $searchNameInput.val();
            var $searchNameLink = $parentElem.find('.save-search-name-link');

            if ($newSearchName.length) {
                SCM.MyAccount.renameSaveSearch($newSearchName, $userSearchId, $searchNameLink);

                $searchNameInput.hide();
                $searchNameLink.show();
                $parentElem.find('.save-search-rename-rename').show();
                $parentElem.find('.save-search-rename-cancel').hide();
                $(this).hide();
            }            
        });

        // save rename on key press
        $('.solrSearchSaveWidget .save-search-input').on('keypress', function (e) {
            var $parentElem = $(this).closest('td');
            var $newSearchName = $(this).val();
            var $searchNameLink = $parentElem.find('.save-search-name-link');

            var code = e.keyCode || e.which;
            if (code === 13) {
                e.preventDefault();

                if ($newSearchName.length) {
                    var $usersearchid = $parentElem.closest('tr').data('usersearchid');

                    SCM.MyAccount.renameSaveSearch($newSearchName, $usersearchid, $searchNameLink);

                    $(this).hide();
                    $searchNameLink.show();
                    $parentElem.find('.save-search-rename-rename').show();
                    $parentElem.find('.save-search-rename-save').hide();
                    $parentElem.find('.save-search-rename-cancel').hide();
                }
            }
        });
    };

    ns.bindTableSorter = function (updatedTable) {
        $(updatedTable).trigger('update');
        var $sort = $(updatedTable).get(0).config.sortList;
        $(updatedTable).trigger('sorton', [$sort]);
    };

    ns.deleteSaveSearch = function (delElem) {
        $('.alerts-wrap-cover').removeClass('uncovered');
        $('.alerts-wrap-cover').addClass('covered');

        var ajaxUrl = '//' + baseSiteUrl.val() + '/Solr/DeleteSolrSearchInfoWithToken';
        var parentElem = delElem.closest('tr');
        var id = parentElem.data('usersearchid');
        var userAlertId = parentElem.data('useralertid');
        var token = $('#SolrSearchAuthToken').val();
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            cache: false, // to defeat browser URL caching
            data: { userSearchId: id, userAlertId: userAlertId, token: token },
            success: function (result) {
                if (result != null) {
                    if (result.ReturnId) {
                        $('#SolrSearchAuthToken').val(result.ReturnId);
                    }
                    $('.solrSearchSaveWidget .solrSearchSaveModel .message').html(result.Html).parent().foundation('reveal', 'open');
                    if (result.Success) {
                        parentElem.remove();
                    }
                }
            },
            error: function (xmlHttpRequest, textStatus) {
                App.Logger.logAjaxError(xmlHttpRequest, textStatus);
            }
        }).done(function () {
            SCM.MyAccount.bindTableSorter($('.saved-searches-table.tablesorter'));
            $('.alerts-wrap-cover').removeClass('covered');
            $('.alerts-wrap-cover').addClass('uncovered');
        });
    };

    ns.changeUserAlert = function (upElem) {
        var ajaxUrl = '//' + baseSiteUrl.val() + '/Solr/UpdateUserAlertWithToken';
        var parentElem = upElem.closest('tr');
        var id = parentElem.data('usersearchid');
        var userAlertId = parentElem.data('useralertid');
        var scheduleId = upElem.val();
        var token = $('#SolrSearchAuthToken').val();
        $('.alerts-wrap-cover').removeClass('uncovered');
        $('.alerts-wrap-cover').addClass('covered');

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            cache: false, // to defeat browser URL caching
            data: { userSearchId: id, userAlertId: userAlertId, scheduleId: scheduleId, token: token },
            success: function (result) {
                if (result != null) {
                    var resultIdObj = JSON.parse(result.ReturnId);
                    if (resultIdObj != null && resultIdObj.Token != null) {
                        $('#SolrSearchAuthToken').val(resultIdObj.Token);
                    }

                    $('.solrSearchSaveWidget .solrSearchSaveModel .message').html(result.Html).parent().foundation('reveal', 'open');
                    if (result.Success && resultIdObj != null && resultIdObj.ReturnId != null) {
                        // if a user toggles switching on/off alert in same session
                        parentElem.data('useralertid', resultIdObj.ReturnId);
                    }
                }
            },
            error: function (xmlHttpRequest, textStatus) {
                App.Logger.logAjaxError(xmlHttpRequest, textStatus);
            }
        })
        .done(function () {
            $('.alerts-wrap-cover').removeClass('covered');
            $('.alerts-wrap-cover').addClass('uncovered');
        });
    };

    ns.renameSaveSearch = function (searchName, userSearchId, $linkElement) {
        var ajaxUrl = '//' + baseSiteUrl.val() + '/Solr/RenameSolrSearchInfoWithToken';
        var token = $('#SolrSearchAuthToken').val();
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            cache: false, // to defeat browser URL caching
            data: { searchName: searchName, userSearchId: userSearchId, token: token },
            success: function (result) {
                if (result != null) {
                    if (result.ReturnId) {
                        $('#SolrSearchAuthToken').val(result.ReturnId);
                    }
                    if (result.Html == 'Updated Successfully') {
                        $linkElement.text(searchName);
                    }
                    $('.solrSearchSaveWidget .solrSearchSaveModel .message').html(result.Html).parent().foundation('reveal', 'open');
                }
            },
            error: function (xmlHttpRequest, textStatus) {
                App.Logger.logAjaxError(xmlHttpRequest, textStatus);
            }
        }).done(function () {
            SCM.MyAccount.bindTableSorter($('.saved-searches-table.tablesorter'));
        });
    };

    ns.initForgotPassword = function () {
        var initialForgotPasswordErrorMessage = $('#forgot-password').find('.error-message').html();
        var pageTitle = document.title;
        $('#forgotPasswordBtn').on('click', function () {
            var $formContainer = $('#forgot-password');

            var $emailInputElement = $formContainer.find('#contactEmail');
            var $inputWrap = $emailInputElement.closest('.input-wrap');
            $inputWrap.removeClass('has-error');

            var $successMsg = $formContainer.find('.success-message');
            var $errMsg = $formContainer.find('.error-message');

            $successMsg.html('').hide();
            $errMsg.html(initialForgotPasswordErrorMessage).hide();

            var email = $emailInputElement.val();
            if (email.length > 0) {
                $.post('/OUPMyAccount/ForgotPassword',
                { email: email },
                function (err) {
                    // Per sequrity reasons we don't show anything if user is not exist in Sigma.
                    var successMsg = $formContainer.find('.success-message-template').html().replace('{0}', email);
                    if (err === null || err === '') {
                        showSuccessMessage($emailInputElement, $successMsg, successMsg, pageTitle);
                    }
                    else {
                        showErrorMessage($errMsg, $inputWrap, $successMsg, $emailInputElement, err, pageTitle);
                    }
                },
                'html');
            }
            else
            {
                showErrorMessage($errMsg, $inputWrap, $successMsg, $emailInputElement, initialForgotPasswordErrorMessage, pageTitle);
            }
            $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
        });

        function showErrorMessage($errMsgElement, $inputWrap, $successMsg, $emailInputElement, err, pageTitle)
        {
            $errMsgElement.html(err).show();
            $inputWrap.addClass('has-error');
            $emailInputElement[0].setAttribute("aria-describedby", "ErrorMessageContactEmail");
            $emailInputElement[0].focus();
            document.title = "Error: " + err + " | " + pageTitle;
        }

        function showSuccessMessage($emailInputElement, $successMsgElement, successMsg) {
            $successMsgElement.html(successMsg).show();
            $emailInputElement[0].removeAttribute("aria-describedby");
            document.title = pageTitle;
        }
        $('#contactEmail').on('keypress', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                $('#forgotPasswordBtn').click();
            }
        });
    };

    ns.initResetPassword = function () {
        $('#changePasswordBtn').on('click', function () {
            var $formContainer = $('#change-password');
            var $successMsg = $formContainer.find('.success-message');
            var $errMsg = $formContainer.find('.error-message');

            var token = SCM.JSUtility.getSearchParamByName('t');
            var newPassword = $formContainer.find('#newPassword').val();
            var confirmNewPassword = $formContainer.find('#confirmNewPassword').val();

            $.post('/OUPMyAccount/ResetPassword',
            { token: token, newPassword: newPassword, confirmNewPassword: confirmNewPassword },
            function (err) {
                if (err == null || err == '') {
                    $successMsg.show();
                    $errMsg.hide();
                }
                else {
                    $successMsg.hide();
                    $errMsg.html(err).show();
                    $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                }
            },
            'html');
        });

        SCM.TestPassword.initTestPassword('#newPassword', '#confirmNewPassword', '#changePasswordBtn');
    };
    
    ns.countSubjectChoices = function () {
        $('#communication-preferences-subject-choices').find('.topics-selected-wrap').each(function () {
            var $totalOptions = $(this).closest('li').find('input[type=checkbox]');
            var $selectedOptions = $totalOptions.filter(':checked');

            $(this).find('.totalCount').html($totalOptions.length);
            $(this).find('.checkedTotal').html($selectedOptions.length);
            $(this).show();
        });
    };

    ns.changeUserTypeSubjects = function (reset) {
        var $container = $('#communication-preferences');
        $('#userTypeSubjectHeader').hide();
        var classificationId = $container.find('#userTypes').val();
        if (classificationId === '3') { // Show this heading only for Librarian 
            $('#userTypeSubjectHeader').show();
        }

        $container.find('ul#userTypeSubjects > li').each(function () {
            var $checkbox = $(this).find('input[type=checkbox]');
            //selected subject
            if ($(this).attr('data-classification-id') === classificationId){
                $(this).show();

                // reset to original choice
                if (reset) {
                    $checkbox.prop('checked', $checkbox.data('checked'));
                }
            }
            else {
                $(this).hide();

                // uncheck all
                if (reset) {
                    $checkbox.prop('checked', false);
                }
            }
        });
    };

    ns.cleanLastErrorMessage = function () {
        $.post('/OUPMyAccount/CleanLastErrorMessage');
    };
    
})(SCM.MyAccount = SCM.MyAccount || {}, jQuery);


/******************************************************************
Copied from MyAccount.aspx, need to be revised
*******************************************************************/
$(document).ready(function () {
    var $emailAlertModal = $('#journalAddEditDiv'),
        $checkboxRows = $('#journalAddEditDiv .add-new-alert .new-alert-row-wrap'),
        currentModalContents;

    // show that myaccounts is doing something
    $(document).on('click', '.myaccount-tabs-inner-wrap div', function () {
        $('.tabbed-content-overlay').show();
    });

    //hide the overlay when the new tab is loaded
    $('#myaccount-tabs-content').on('DOMSubtreeModified', function () {
        $('.tabbed-content-overlay').hide();
    });

    $('#institutionalLogoURL').keyup(function () {
        $('.logoPreview').attr('src', $(this).val());
        $('.logoPreview').error(function () {
            $(this).attr('src', '/Images/grey.gif');
        });
    });

    /**
     * Restores checkbox states for Email Alert Modals when user closes the modal without clicking the submit button
     * 
     * @param  click target
     */
    var restoreCheckboxes = function (target) {
        // if the modal is open AND something other than the submit button was clicked (closed without save) ...
        if ($emailAlertModal.hasClass('open') && !target.hasClass('js-save-alerts')) {
            // once the modal is closed ...
            $(document).on('closed.fndtn.reveal', '[data-reveal]', function () {
                // copy the HTML stored in currentModalContents into the modal
                $checkboxRows.html(currentModalContents);
            });
        }
    };

    // capture contents of Email Alert Modals modal when one opens
    $(document).on('opened.fndtn.reveal', '[data-reveal]', function () {
        currentModalContents = $checkboxRows.html();

        $(document).on('mouseup.myAccount', function (e) {
            var $target = $(e.target);
            restoreCheckboxes($target);
        });

        // for keyboard users (accessibility)
        $(document).on('keyup.myAccount', function (e) {
            var $target = $(e.target);
            restoreCheckboxes($target);
        });
    });

    // unbind when modal closes
    $(document).on('closed.fndtn.reveal', '[data-reveal]', function () {
        $(document).off('mouseup.myAccount');
        $(document).off('keyup.myAccount');
    });

    SCM.PasswordDisplayToggle.init('#Password, #ConfirmPassword', '.widget-Register');
    SCM.MyAccount.initInstitutionalSettings();
    SCM.MyAccount.initSubscriptions();
    App.MyEmailAlerts.init();
});